import axios from 'axios'

export function fetchNotes ({ commit, getters }, params = {}) {
  delete params.rowsNumber

  return axios.get('/api/notes', { params })
    .then(response => response.data)
    .then(result => {
      if (result.data) {
        commit('setNotes', result.data)
        commit('setPagination', Object.assign({}, getters['getPagination'], {
          page: result.current_page,
          rowsPerPage: result.per_page,
          rowsNumber: result.total
        }))
      } else {
        commit('setNotes', result)
      }
    })
}

export function fetchFormFields ({ commit }) {
  return axios.get('/api/config/forms', { params: { model: 'note' } })
    .then(response => response.data)
    .then(result => { commit('setFormFields', result) })
}

export function fetchFilters ({ commit }) {
  return axios.get('/api/config/filters', { params: { model: 'note' } })
    .then(response => response.data)
    .then(result => { commit('setFilters', result) })
}

export function getNote ({ commit }, id) {
  return axios.get(`/api/notes/${id}`)
    .then(response => response.data)
    .then(note => { commit('setCurrentNote', note) })
}

export function saveNote ({ commit }, params = {}) {
  const { id } = params

  const apiVerb = id ? 'patch' : 'post'
  const apiRoute = id ? `/api/notes/${id}` : '/api/notes/'
  const data = params.id ? params : params

  return axios.request({
    method: apiVerb,
    url: apiRoute,
    data
  }).then(response => response.data)
}

export function deleteNote ({ commit }, id) {
  return axios.delete(`/api/notes/${id}`)
    .then(response => response.data)
}
